import Page from "../../finwell/pages/Page";
import Loader from "../../components/Loader/Loader";
import { useEffect, useState } from "react";
import CourseReportHomeSection from "../../components/Reports/courseProgress/CourseReportHomeSection";

export const CourseProgressReportPage = () => {
    const [isLoading, setIsLoading] = useState(false);
    useEffect(() => {
        window.scrollTo(0, 0);
    }, [])
    return (
        <>
        <Loader start={isLoading} />
        <Page>
            <CourseReportHomeSection 
                setIsLoading={setIsLoading}
                isLoading={isLoading}
            />
        </Page>
        </>
    )
}

export default CourseProgressReportPage;